import type { Bulletin } from '@shared/types/Bulletin';
import type { Salarie } from '@shared/types/Salarie';

/**
 * Décision du dirigeant du 22/10/2026 (D7, recette 1.1.6) : avertir à l'export (AD-01, CNAMGS, DTS) quand le numéro
 * CNSS ou CNAMGS d'un salarié manque ou n'est pas valide. L'export n'est jamais bloqué.
 */
export interface SalarieSansIdentifiant {
  salarieId: string;
  matricule: string;
  nom: string;
}

/**
 * Salariés des bulletins donnés dont l'identifiant (n° CNSS ou CNAMGS) est absent ou invalide.
 * Chaque salarié n'apparaît qu'une fois, même s'il a plusieurs bulletins ; l'ordre d'apparition est conservé.
 */
export function salariesSansIdentifiant(
  bulletins: readonly Bulletin[],
  salaries: readonly Salarie[],
  identifiantDe: (salarie: Salarie) => string,
  estValide: (identifiant: string) => boolean,
): SalarieSansIdentifiant[] {
  const parId = new Map(salaries.map((s) => [s.id, s]));
  const vus = new Set<string>();
  const manquants: SalarieSansIdentifiant[] = [];
  for (const b of bulletins) {
    if (vus.has(b.salarie_id)) continue;
    vus.add(b.salarie_id);
    const salarie = parId.get(b.salarie_id);
    if (!salarie) continue;
    if (estValide(identifiantDe(salarie))) continue;
    manquants.push({
      salarieId: salarie.id,
      matricule: salarie.matricule,
      nom: `${salarie.prenom ?? ''} ${salarie.nom ?? ''}`.trim(),
    });
  }
  return manquants;
}
